module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [(_vm.adImg) ? [(_vm.adImg) ? _c('div', {
    staticClass: "banner-bg ad"
  }, [_c('img', {
    attrs: {
      "src": _vm.adImg,
      "alt": "ad"
    }
  }), _vm._v(" "), _c('span', [_vm._v("广告")])]) : _vm._e()] : [_c('div', {
    staticClass: "banner-bg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/promotion_bg.jpg"),
      "alt": "cover"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('span', {
    staticClass: "download"
  }, [_vm._v("极速下载")]), _vm._v(" "), _c('span', {
    staticClass: "open"
  }, [_vm._v("打开")])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaa1c104"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 206
// module chunks = 0